
import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultTeleMedicineService = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultTeleMedicineService' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> INFORMED CONSENT TO PARTICIPATE IN TELE-MEDICINE SERVICES  </center> </b>
                </p>
                <p className='w-750'>
                    Jackson Hands of Change and <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only w-200 custom-add-only' /> , have requested/suggested that I, <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only w-200 custom-add-only' /> , receive behavioral health/psychiatric services by telemedicine. I have been informed of my/my child's diagnosis and treatment plan by <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only w-200 custom-add-only' />. I understand that I will be receiving health care services though interactive videoconferencing equipment. I understand that, at this time, there are no known risks involved in my receiving services through telemedicine and that these services are confidential and my privacy will be carefully maintained. I understand that these services will be delivered through encrypted/HIPAA-compliant videoconferencing that is as equally secure as all electronic medical communication and health records. I understand that I will be informed of all participants in both the originating site/clinic and the distant site.
                </p>
                <p className='w-750'>
                    I understand that the equipment will be shown to me and I will see how it works before I receive any services. I understand that my participation in telemedicine is voluntary, but that telemedicine will significantly increase my access to services. I understand that I may refuse to participate or decide to stop participating at any time, verbally or in writing. I understand that my refusal to participate or decision to stop participation will be documented in my medical record. However, I also understand that scheduling may be affected by my refusal to participate in telemedicine services.
                </p>
                <p className='w-750'>
                    I understand that health care providers at both my location and the remote video site, Jackson Hands of Change, will have access to any relevant information about me including any psychiatric and/or psychological information, alcohol and/or drug abuse, and mental health records.
                </p>
                <p className='w-750'>
                    I have read this document and I hereby consent to participate in receiving behavioral health/psychiatric services by telemedicine under the terms described above. I understand this document will become a part of my medical record.
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbConsent_1' name='cbConsent_1' className='add-only' value='Consent_1' /> I agree to participate in and receive behavioral health LMHP, Psychiatric, and/or MHP/MHS  services by telemedicine.
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbConsent_2' name='cbConsent_2' className='add-only' value='Consent_2' /> I choose not to participate in behavioral health LMHP, Psychiatric, and/or MHP/MHS  services by telemedicine.

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}